(() => {
  const popup = document.getElementById('HinoichiLineExitPopup');
  if (!popup || Shopify.designMode) return;

  const SESSION_KEY = 'hinoichiLineOfferShown';
  const DISMISSED_KEY = 'hinoichiLineOfferDismissedAt';
  const DISMISS_FOR_MS = 14 * 24 * 60 * 60 * 1000;
  const MIN_DWELL_MS = 30 * 1000;
  const MIN_SCROLL_RATIO = 0.5;

  const closeButton = popup.querySelector('[data-hinoichi-exit-close]');
  const offerLink = popup.querySelector('[data-hinoichi-exit-link]');
  let dwellReached = false;
  let scrollReached = false;
  let visible = false;

  const storageGet = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch (_error) {
      return null;
    }
  };

  const storageSet = (storage, key, value) => {
    try {
      storage.setItem(key, value);
    } catch (_error) {
      // Storage can be unavailable in privacy modes; the popup still remains dismissible.
    }
  };

  const dismissedAt = Number(storageGet(window.localStorage, DISMISSED_KEY) || 0);
  const recentlyDismissed = dismissedAt > 0 && Date.now() - dismissedAt < DISMISS_FOR_MS;
  const shownThisSession = storageGet(window.sessionStorage, SESSION_KEY) === 'true';

  if (recentlyDismissed || shownThisSession) return;

  const show = () => {
    if (visible || !dwellReached || !scrollReached || document.visibilityState !== 'visible') return;

    visible = true;
    storageSet(window.sessionStorage, SESSION_KEY, 'true');
    popup.hidden = false;
    popup.inert = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hinoichi-exit-popup-open');
    window.requestAnimationFrame(() => popup.classList.add('is-visible'));
  };

  const hide = (rememberDismissal) => {
    if (!visible) return;

    visible = false;
    popup.classList.remove('is-visible');
    popup.inert = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hinoichi-exit-popup-open');

    if (rememberDismissal) {
      storageSet(window.localStorage, DISMISSED_KEY, String(Date.now()));
    }

    window.setTimeout(() => {
      if (!visible) popup.hidden = true;
    }, 200);
  };

  const checkScroll = () => {
    const scrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
    const ratio = scrollable === 0 ? 1 : window.scrollY / scrollable;

    if (ratio >= MIN_SCROLL_RATIO) {
      scrollReached = true;
      window.removeEventListener('scroll', checkScroll);
      show();
    }
  };

  closeButton.addEventListener('click', () => hide(true));
  offerLink.addEventListener('click', () => hide(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && visible) {
      hide(true);
    }
  });

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  window.setTimeout(() => {
    dwellReached = true;
    show();
  }, MIN_DWELL_MS);
})();
